import { diContainer } from "@/core/di";
import AbstractDownloadHandler from "./AbstractDownloadHandler";
import { MimeTypes, IDownload } from "../types";
import { DITypes } from "@/core/@types/types";
import "reflect-metadata";
import { injectable } from "inversify";

@injectable()
export default class PNGDownloadHandler extends AbstractDownloadHandler {
  handle(mimeType: MimeTypes): IDownload | null {
    if (mimeType === MimeTypes.PNG)
      return diContainer.get<IDownload>(DITypes.DOWNLOAD_PNG);

    return super.handle(mimeType);
  }
}
